import React from "react";
import Reveal from "./Reveal";

export default function FigureBlock({ src, alt, caption, num = "1", ratio = "16/10", className = "" }) {
    return (
        <Reveal className={className}>
            <figure className="group" data-testid={`figure-${num}`}>
                <div className="relative overflow-hidden border border-white/10 bg-sheet" style={{ aspectRatio: ratio }}>
                    <img
                        src={src}
                        alt={alt}
                        loading="lazy"
                        className="img-treat absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 pointer-events-none scanlines" />
                    <span className="absolute top-3 left-3 font-mono text-[10px] uppercase tracking-[0.25em] bg-ink/70 backdrop-blur px-2 py-1 text-amber border border-amber/30">
                        FIG {num}
                    </span>
                </div>
                <figcaption className="mt-3 flex gap-3">
                    <span className="font-mono text-[11px] text-amber shrink-0">Fig. {num}</span>
                    <span className="font-mono text-[11px] leading-relaxed text-ash">{caption}</span>
                </figcaption>
            </figure>
        </Reveal>
    );
}
